import { z } from "zod";

const MANUAL_LINK_ALLOWED_HOST = "trustart.notion.site";

const manualLinkSchema = z
  .string()
  .max(1000)
  .refine((value) => value.trim() !== "", "link must not be blank")
  .refine((value) => {
    try {
      const url = new URL(value);
      return (
        url.protocol === "https:" &&
        url.hostname === MANUAL_LINK_ALLOWED_HOST &&
        url.port === "" &&
        url.username === "" &&
        url.password === ""
      );
    } catch {
      return false;
    }
  }, "link must be an allowed HTTPS URL");

export const manualSearchResponseSchema = z
  .array(
    z.object({
      title: z
        .string()
        .max(300)
        .refine((value) => value.trim() !== "", "title must not be blank"),
      link: manualLinkSchema,
    })
  )
  .max(3);
